module.exports = __webpack_public_path__ + "img/meta-icon2.eb3c91bc.png";